import Vue from "vue";
import Router from "vue-router";
import Base from "./views/Base.vue";
import Home from "./views/Home.vue";
import Contact from "./views/Contact.vue";
import Post from "./views/Post.vue";
import Blog from "./views/Blog.vue";
import Parc from "./views/Parc.vue";
import NosParcs from "./views/NosParcs.vue";
import Tarifs from "./views/Tarifs.vue";
import Visit from "./views/Visit.vue";
import Anniversaires from "./views/Anniversaires.vue";
import NotFound from "./views/NotFound.vue";
import Seminaires from "./views/Seminaires.vue";
import SeminairesTest from "./views/SeminairesTest.vue";
import Test from "./views/Test.vue";
import TestLib from "./views/TestLibrairieCug.vue";
import Collectivites from "./views/Collectivites.vue";
import Scolaires from "./views/Scolaires.vue";
import Ce from "./views/CE.vue";
import CeTest from "./views/CeTest.vue";
import CeTicket from "./views/CeTicket.vue";
import CeTicketAlbigny from "./views/CeTicketAlbigny.vue";
import CeAchat from "./views/CeAchat.vue";
import Restauration from "./views/Restauration.vue";
import Kayak from "./views/Kayak.vue";
import Horaires from "./views/Horaires.vue";
import Conseils from "./views/Conseils.vue";
import Mentions from "./views/MentionsLegales.vue";
import Presse from "./views/Presse.vue";
import Attractions from "./views/Attractions.vue";
import BonsPlans from "./views/BonsPlans.vue";
import Partenaires from "./views/Partenaires.vue";
import Cahute from "./views/LaCahute.vue";
import Evg from "./views/Evg.vue";
import NousTrouver from "./views/NousTrouver.vue";
import Shop from "./views/Shop.vue";
import Callback from "./views/Callback.vue";
import Canoe from "./views/Canoe.vue";
import BilleterieSommaire from "./views/BilleterieSommaire.vue";
import Afterworks from "./views/Afterworks.vue";
import ParcLyonFerme from "./views/ParcLyonFerme.vue";
import Checkout from "./views/Checkout.vue";
import Covid from "./views/Covid.vue";
import Faq from "./views/Faq.vue";
import Recrutement from "./views/Recrutement.vue";
import Job from "./views/Job.vue";
import ShopSteFoyCug from "./views/ShopSteFoyCug.vue";
import EvasionTestCug from "./views/EvasionTestCug.vue";
import SellOpenTickets from "./views/SellOpenTickets.vue";
import CartProduct from "./views/Cart/Product.vue";
import CartPayment from "./views/Cart/Payment.vue";
import CartCustomer from "./views/Cart/Customer.vue";
import Slug from "./views/_slug.vue";

import CartProductAlbigny from "./views/CartAlbigny/Product.vue";
import CartPaymentAlbigny from "./views/CartAlbigny/Payment.vue";
import CartCustomerAlbigny from "./views/CartAlbigny/Customer.vue";

import ShopPage from "./views/Shop/ShopPage.vue";
import Account from "./views/Account/Account.vue";
import NewPassword from "./views/Account/NewPassword.vue";
import ResetPassword from "./views/Account/ResetPassword.vue";
import SignIn from "./views/Account/SignIn.vue";
import SignUp from "./views/Account/SignUp.vue";

import i18n from "./i18n";
import api from "@/api";
import ShopAlbigny from "./views/ShopAlbigny";
import CheckoutAlbigny from "./views/CheckoutAlbigny";
import { faSignInAlt } from "@fortawesome/free-solid-svg-icons";

import { STEFOY_CONFIG, ALBIGNY_CONFIG } from "./assets/allosv.config";
Vue.use(Router);

const routes = [
  {
    path: "",
    alias: "pages/index",
    name: "index",
    component: Home,
    meta: {
      title: "home"
    }
  },
  {
    path: "cart/product",
    name: "cart-product",
    component: CartProduct,
    meta: {
      title: "cart-product"
    }
  },
  {
    path: "cart/payment",
    name: "cart-payment",
    component: CartPayment,
    meta: {
      title: "cart-payment"
    }
  },
  {
    path: "cart/customer",
    name: "cart-customer",
    component: CartCustomer,
    meta: {
      title: "cart-customer"
    }
  },

  {
    path: "cart/product-albigny",
    name: "cart-product-albigny",
    component: CartProductAlbigny,
    meta: {
      title: "cart-product-albigny"
    }
  },
  {
    path: "cart/payment-albigny",
    name: "cart-payment-albigny",
    component: CartPaymentAlbigny,
    meta: {
      title: "cart-payment-albigny"
    }
  },
  {
    path: "cart/customer-albigny",
    name: "cart-customer-albigny",
    component: CartCustomerAlbigny,
    meta: {
      title: "cart-customer-albigny"
    }
  },

  {
    path: "kayak",
    name: "kayak",
    component: Kayak,
    meta: {
      title: "kayak"
    }
  },
  {
    path: "shop",
    name: "shop",
    redirect: "boutique/boutique-stefoy",
    meta: {
      title: "shop"
    }
  },
  {
    path: "shop-success",
    name: "shop-success",
    redirect: "boutique/stefoy-success",
    meta: {
      title: "shop-success"
    }
  },
  {
    path: "shop-error",
    name: "shop-error",
    redirect: "boutique/stefoy-error",
    meta: {
      title: "shop-error"
    }
  },
  {
    path: "shop-albigny",
    name: "shop-albigny",
    redirect: "boutique/boutique-albigny",
    meta: {
      title: "shop-albigny"
    }
  },
  {
    path: "shop-albigny-success",
    name: "shop-albigny-success",
    redirect: "boutique/albigny-success",
    meta: {
      title: "shop-albigny-success"
    }
  },
  {
    path: "shop-albigny-error",
    name: "shop-albigny-error",
    redirect: "boutique/albigny-error",
    meta: {
      title: "shop-albigny-error"
    }
  },
  {
    path: "payzen/response",
    name: "callback",
    component: Callback,
    meta: {
      title: "Retour de boutique"
    }
  },
  {
    path: "checkout",
    name: "checkout",
    component: Checkout,
    meta: {
      title: "checkout"
    }
  },
  {
    path: "checkout-albigny",
    name: "checkout-albigny",
    component: CheckoutAlbigny,
    meta: {
      title: "checkout-albigny"
    }
  },
  {
    path: "blog",
    alias: "pages/blog",
    name: "blog",
    component: Blog,
    meta: {
      title: "blog"
    }
  },

  {
    path: "blog/:id",
    //alias: "pages/blog/index",
    name: "post",
    component: Post,
    meta: {
      title: "post"
    }
  },
  {
    path: "parcs/:id",
    alias: "pages/parcs/:id",
    name: "parc",
    component: Parc,
    meta: {
      title: "parc"
    }
  },
  {
    path: "nous-trouver/:id",
    alias: "pages/nous-trouver/:id",
    name: "nous-trouver",
    component: NousTrouver,
    meta: {
      title: "nous-trouver"
    }
  },
  {
    path: "visite/:id",
    alias: "pages/visite/:id",
    name: "visit",
    component: Visit,
    meta: {
      title: "visite"
    }
  },
  {
    path: "nos-parcs",
    alias: "pages/nos-parcs",
    name: "nos-parcs",
    component: NosParcs,
    meta: {
      title: "nos-parcs"
    }
  },
  {
    path: "attractions/:id",
    alias: "pages/attractions/:id",
    name: "attraction",
    component: Attractions,
    meta: {
      title: "attractions"
    }
  },
  {
    path: "contact/:id",
    alias: "pages/contact/:id",
    name: "contact",
    component: Contact,
    meta: {
      title: "contact"
    }
  },
  {
    path: "tarifs",
    alias: "pages/tarifs",
    name: "tarifs",
    component: Tarifs,
    meta: {
      title: "tarifs"
    }
  },
  {
    path: "covid-19",
    alias: "pages/covid-19",
    name: "covid19",
    component: Covid,
    meta: {
      title: "Covid 19"
    }
  },
  {
    path: "canoe",
    alias: "pages/canoe",
    name: "canoe",
    component: Canoe,
    meta: {
      title: "canoe"
    }
  },
  {
    path: "billetterie-sommaire",
    alias: "pages/billetterie-sommaire",
    name: "billetterie-sommaire",
    component: BilleterieSommaire,
    meta: {
      title: "billetterie-sommaire"
    }
  },
  {
    path: "afterworks",
    alias: "pages/afterworks",
    name: "afterworks",
    component: Afterworks,
    meta: {
      title: "afterworks"
    }
  },
  {
    path: "parc-lyon-albigny-temporairement-ferme",
    alias: "pages/parc-lyon-albigny-temporairement-ferme",
    name: "parc-lyon-albigny-temporairement-ferme",
    component: ParcLyonFerme,
    meta: {
      title: "parclyonferme"
    }
  },
  {
    path: "anniversaires",
    alias: "pages/anniversaires",
    name: "anniversaires",
    component: Anniversaires,
    meta: {
      title: "anniversaires"
    }
  },
  {
    path: "se-restaurer",
    alias: "pages/se-restaurer",
    name: "restauration",
    component: Restauration,
    meta: {
      title: "restauration"
    }
  },
  {
    path: "conseils-malins",
    alias: "pages/conseils-malins",
    name: "conseils",
    component: Conseils,
    meta: {
      title: "conseils"
    }
  },
  {
    path: "horaires/:id",
    alias: "pages/horaires/:id",
    name: "horaires",
    component: Horaires,
    meta: {
      title: "horaires"
    }
  },
  {
    path: "partenaires",
    alias: "pages/partenaires",
    name: "partenaires",
    component: Partenaires,
    meta: {
      title: "partenaires"
    }
  },
  {
    path: "seminaires",
    alias: "pages/seminaires",
    name: "seminaires",
    component: Seminaires,
    meta: {
      title: "séminaires-perchés",
      layout: "empty"
    }
  },
  {
    path: "seminaires-test",
    alias: "pages/seminaires-test",
    name: "seminairesTest",
    component: SeminairesTest,
    meta: {
      title: "séminaires-test",
      layout: "empty"
    }
  },
  {
    path: "test",
    alias: "pages/test",
    name: "test",
    component: Test,
    meta: {
      title: "séminaires-perchés",
      layout: "empty"
    }
  },
  {
    path: "collectivites",
    alias: "pages/collectivites",
    name: "collectivites",
    component: Collectivites,
    meta: {
      title: "collectivités"
    }
  },
  {
    path: "scolaires",
    alias: "pages/scolaires",
    name: "scolaires",
    component: Scolaires,
    meta: {
      title: "scolaires"
    }
  },
  {
    path: "bons-plans",
    alias: "pages/bons-plans",
    name: "bons-plans",
    component: BonsPlans,
    meta: {
      title: "bons-plans"
    }
  },
  {
    path: "ce",
    alias: "pages/ce",
    name: "ce",
    component: Ce,
    meta: {
      title: "ce"
    }
  },
  {
    path: "ce-test",
    alias: "pages/ce-test",
    name: "ce-test",
    component: CeTest,
    meta: {
      title: "ce-test"
    }
  },
  {
    path: "ce-ticket",
    alias: "pages/ce-ticket",
    name: "ce-ticket",
    component: CeTicket,
    meta: {
      title: "ce-ticket"
    }
  },
  {
    path: "ce-ticket-albigny",
    alias: "pages/ce-ticket-albigny",
    name: "ce-ticket-albigny",
    component: CeTicketAlbigny,
    meta: {
      title: "ce-ticket-albigny"
    }
  },
  {
    path: "shop-stefoy-cug",
    alias: "pages/shop-stefoy-cug",
    name: "shop-stefoy-cug",
    component: ShopSteFoyCug,
    meta: {
      title: "shop-stefoy-cug"
    }
  },
  {
    path: "evasion-test-cug",
    alias: "pages/evasion-test-cug",
    name: "evasion-test-cug",
    component: EvasionTestCug,
    meta: {
      title: "evasion-test-cug"
    }
  },
  {
    path: "achats-tickets-open",
    alias: "pages/achats-tickets-open",
    name: "achats-tickets-open",
    component: SellOpenTickets,
    meta: {
      title: "achats-tickets-open"
    }
  },
  {
    path: "ce-achat",
    alias: "pages/ce-achat",
    name: "ce-achat",
    component: CeAchat,
    meta: {
      title: "ce-achat"
    }
  },
  {
    path: "la-cahute/:id",
    alias: "pages/la-cahute/:id",
    name: "la-cahute",
    component: Cahute,
    meta: {
      title: "cahute"
    }
  },
  {
    path: "mentions-legales",
    alias: "pages/mentions-legales",
    name: "mentions-legales",
    component: Mentions,
    meta: {
      title: "mentions-legales"
    }
  },
  {
    path: "presse",
    alias: "pages/presse",
    name: "presse",
    component: Presse,
    meta: {
      title: "presse"
    }
  },

  {
    path: "evg-evjf",
    alias: "pages/evg-evjf",
    name: "evg-evjf",
    component: Evg,
    meta: {
      title: "evg-evjf"
    }
  },

  {
    path: "test-lib",
    alias: "pages/test-lib",
    name: "test-lib",
    component: TestLib,
    meta: {
      title: "test-lib"
    }
  },

  {
    path: "recrutement",
    alias: "pages/recrutement",
    name: "recrutement",
    component: Recrutement,
    meta: {
      title: "recrutement"
    }
  },
  {
    path: "faq",
    alias: "pages/faq",
    name: "faq",
    component: Faq,
    meta: {
      title: "faq"
    }
  },
  {
    path: "account/account",
    alias: "pages/account/account",
    name: "account",
    component: Account,
    meta: {
      title: "account"
    }
  },
  {
    path: "account/new-password",
    alias: "pages/account/new-password",
    name: "new-password",
    component: NewPassword,
    meta: {
      title: "new-password"
    }
  },
  {
    path: "account/reset-password",
    alias: "pages/account/reset-password",
    name: "reset-password",
    component: ResetPassword,
    meta: {
      title: "reset-password"
    }
  },
  {
    path: "account/sign-in",
    alias: "pages/account/sign-in",
    name: "sign-in",
    component: SignIn,
    meta: {
      title: "sign-in"
    }
  },
  {
    path: "account/sign-up",
    alias: "pages/account/sign-up",
    name: "sign-up",
    component: SignUp,
    meta: {
      title: "sign-up"
    }
  },
  {
    path: "boutique/:shopPageId",
    alias: "pages/boutique/shop-page",
    name: "shop-page",
    component: ShopPage,
    meta: {
      title: "shop-page"
    }
  },
  {
    path: "job/:jobId",
    alias: "pages/job",
    name: "job",
    component: Job,
    meta: {
      title: "recrutement"
    }
  },
  {
    path: "404",
    name: "Erreur 404",
    component: NotFound,
    meta: {
      title: "404-not-found",
      layout: "default"
    }
  },
  {
    path: ":slug",
    name: "slug",
    component: Slug,
    meta: {
      title: "City Adventure",
      layout: "default"
    }
  }
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      alias: "/pages/index",
      redirect: "/fr"
    },
    {
      path: "/index",
      redirect: "/fr/"
    },
    {
      path: "/cse",
      redirect: "/fr/ce-ticket"
    },
    {
      path: "/:locale",
      component: Base,
      children: routes
    }
  ]
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  let langs = Object.keys(i18n.messages);
  if (langs.includes(to.params.locale)) {
    i18n.locale = to.params.locale;
    let xTitle = router.app.$t(`documentTitle.${to.meta.title.toString()}`);
    document.title = `${xTitle} - City Aventure`;
    next();
  } else {
    next(`/fr${to.path}`);
  }
});

router.beforeEach(async (to, from, next) => {
  try {
    Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(el =>
      el.parentNode.removeChild(el)
    );
    let slug = to.path.slice(4, to.path.length);
    if (slug == "") {
      slug = "index";
    }

    const { data } = await api.get(`cdn/stories/${i18n.locale}/pages/${slug}`);
    console.log(data.story.content);
    const sbPage = data.story.content;

    if (sbPage.parc === "alb") {
      window.__osvConf = ALBIGNY_CONFIG;
    } else if (sbPage.parc === "stefoy") {
      window.__osvConf = STEFOY_CONFIG;
    }

    if (sbPage.seo_title) {
      const title = document.createElement("meta");
      title.setAttribute("name", "title");
      title.setAttribute("content", sbPage.seo_title);
      title.setAttribute("data-vue-router-controlled", "");
      document.head.appendChild(title);
    }

    if (sbPage.seo_description) {
      const description = document.createElement("meta");
      description.setAttribute("name", "description");
      description.setAttribute("content", sbPage.seo_description);
      description.setAttribute("data-vue-router-controlled", "");
      document.head.appendChild(description);
    }

    const link = document.createElement("meta");
    link.setAttribute("rel", "canonical");
    link.setAttribute("href", window.location.href);
    link.setAttribute("data-vue-router-controlled", "");
    document.head.appendChild(link);
    next();
  } catch (error) {
    console.log("error " + error);
    next();
  }
  next();
});

export default router;
